// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IHVVeG3MK75UGSdWUBIE, .xAncdHs887PeRm39FoP3, .QI0j7qRgEpZFwc05Cz5p, .d5yTkvloL2fbjCo5282D, .FYLE_kH5dNaS_zyQfyiN, .jmH8GGrnonSAsQbAwaGw, .RFIN8XQaf3hK0ILalkv9, .LnaR2_M1qxYAXTSGif2f, .t4cOO69YM6V7JszTNi2l, .PmV0ICIftsQf4Ud0PKuA, .C7L4aYXST199UoHysvfs {
  max-width: 100%;
  width: fit-content;
  white-space: pre;
  height: 48px;
  transition: all 0.2s ease-in-out;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 92px;
  /* Proposal Buttons */
  /* Auto layout */
  display: flex;
  padding: 12px 16px;
  backdrop-filter: blur(1px);
  border-radius: 2px;
  font-family: "Bai Jamjuree";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  background: transparent;
}
@media (max-width: 1500px) {
  .IHVVeG3MK75UGSdWUBIE, .xAncdHs887PeRm39FoP3, .QI0j7qRgEpZFwc05Cz5p, .d5yTkvloL2fbjCo5282D, .FYLE_kH5dNaS_zyQfyiN, .jmH8GGrnonSAsQbAwaGw, .RFIN8XQaf3hK0ILalkv9, .LnaR2_M1qxYAXTSGif2f, .t4cOO69YM6V7JszTNi2l, .PmV0ICIftsQf4Ud0PKuA, .C7L4aYXST199UoHysvfs {
    font-size: 14px;
  }
}
@media (max-width: 1200px) {
  .IHVVeG3MK75UGSdWUBIE, .xAncdHs887PeRm39FoP3, .QI0j7qRgEpZFwc05Cz5p, .d5yTkvloL2fbjCo5282D, .FYLE_kH5dNaS_zyQfyiN, .jmH8GGrnonSAsQbAwaGw, .RFIN8XQaf3hK0ILalkv9, .LnaR2_M1qxYAXTSGif2f, .t4cOO69YM6V7JszTNi2l, .PmV0ICIftsQf4Ud0PKuA, .C7L4aYXST199UoHysvfs {
    padding-left: 12px;
    padding-right: 12px;
  }
}
@media (max-width: 400px) or (max-height: 750px) {
  .IHVVeG3MK75UGSdWUBIE, .xAncdHs887PeRm39FoP3, .QI0j7qRgEpZFwc05Cz5p, .d5yTkvloL2fbjCo5282D, .FYLE_kH5dNaS_zyQfyiN, .jmH8GGrnonSAsQbAwaGw, .RFIN8XQaf3hK0ILalkv9, .LnaR2_M1qxYAXTSGif2f, .t4cOO69YM6V7JszTNi2l, .PmV0ICIftsQf4Ud0PKuA, .C7L4aYXST199UoHysvfs {
    padding-top: 8px;
    padding-bottom: 8px;
    height: 40px;
  }
}
@media (max-width: 380px) {
  .IHVVeG3MK75UGSdWUBIE, .xAncdHs887PeRm39FoP3, .QI0j7qRgEpZFwc05Cz5p, .d5yTkvloL2fbjCo5282D, .FYLE_kH5dNaS_zyQfyiN, .jmH8GGrnonSAsQbAwaGw, .RFIN8XQaf3hK0ILalkv9, .LnaR2_M1qxYAXTSGif2f, .t4cOO69YM6V7JszTNi2l, .PmV0ICIftsQf4Ud0PKuA, .C7L4aYXST199UoHysvfs {
    padding-left: 8px;
    padding-right: 8px;
  }
}
.IHVVeG3MK75UGSdWUBIE > ._qLXWE36Y3wnE7_nfGh5, .xAncdHs887PeRm39FoP3 > ._qLXWE36Y3wnE7_nfGh5, .QI0j7qRgEpZFwc05Cz5p > ._qLXWE36Y3wnE7_nfGh5, .d5yTkvloL2fbjCo5282D > ._qLXWE36Y3wnE7_nfGh5, .FYLE_kH5dNaS_zyQfyiN > ._qLXWE36Y3wnE7_nfGh5, .jmH8GGrnonSAsQbAwaGw > ._qLXWE36Y3wnE7_nfGh5, .RFIN8XQaf3hK0ILalkv9 > ._qLXWE36Y3wnE7_nfGh5, .LnaR2_M1qxYAXTSGif2f > ._qLXWE36Y3wnE7_nfGh5, .t4cOO69YM6V7JszTNi2l > ._qLXWE36Y3wnE7_nfGh5, .PmV0ICIftsQf4Ud0PKuA > ._qLXWE36Y3wnE7_nfGh5, .C7L4aYXST199UoHysvfs > ._qLXWE36Y3wnE7_nfGh5 {
  transition: all 0.2s ease-in-out;
  margin: auto 0 auto 15px;
  min-width: fit-content;
}
.IHVVeG3MK75UGSdWUBIE > .plV4OFCIYvubAq6Cd_PT, .xAncdHs887PeRm39FoP3 > .plV4OFCIYvubAq6Cd_PT, .QI0j7qRgEpZFwc05Cz5p > .plV4OFCIYvubAq6Cd_PT, .d5yTkvloL2fbjCo5282D > .plV4OFCIYvubAq6Cd_PT, .FYLE_kH5dNaS_zyQfyiN > .plV4OFCIYvubAq6Cd_PT, .jmH8GGrnonSAsQbAwaGw > .plV4OFCIYvubAq6Cd_PT, .RFIN8XQaf3hK0ILalkv9 > .plV4OFCIYvubAq6Cd_PT, .LnaR2_M1qxYAXTSGif2f > .plV4OFCIYvubAq6Cd_PT, .t4cOO69YM6V7JszTNi2l > .plV4OFCIYvubAq6Cd_PT, .PmV0ICIftsQf4Ud0PKuA > .plV4OFCIYvubAq6Cd_PT, .C7L4aYXST199UoHysvfs > .plV4OFCIYvubAq6Cd_PT {
  margin: 0 8px 0 0 !important;
}
.IHVVeG3MK75UGSdWUBIE[disabled], [disabled].xAncdHs887PeRm39FoP3, [disabled].QI0j7qRgEpZFwc05Cz5p, [disabled].d5yTkvloL2fbjCo5282D, [disabled].FYLE_kH5dNaS_zyQfyiN, [disabled].jmH8GGrnonSAsQbAwaGw, [disabled].RFIN8XQaf3hK0ILalkv9, [disabled].LnaR2_M1qxYAXTSGif2f, [disabled].t4cOO69YM6V7JszTNi2l, [disabled].PmV0ICIftsQf4Ud0PKuA, [disabled].C7L4aYXST199UoHysvfs {
  cursor: not-allowed;
  background: rgba(255, 255, 255, 0.1019607843) !important;
  border: 1px solid rgba(255, 255, 255, 0.1019607843);
  color: rgba(255, 255, 255, 0.5019607843) !important;
}
.IHVVeG3MK75UGSdWUBIE[disabled]:hover, [disabled].xAncdHs887PeRm39FoP3:hover, [disabled].QI0j7qRgEpZFwc05Cz5p:hover, [disabled].d5yTkvloL2fbjCo5282D:hover, [disabled].FYLE_kH5dNaS_zyQfyiN:hover, [disabled].jmH8GGrnonSAsQbAwaGw:hover, [disabled].RFIN8XQaf3hK0ILalkv9:hover, [disabled].LnaR2_M1qxYAXTSGif2f:hover, [disabled].t4cOO69YM6V7JszTNi2l:hover, [disabled].PmV0ICIftsQf4Ud0PKuA:hover, [disabled].C7L4aYXST199UoHysvfs:hover {
  opacity: 1 !important;
  color: rgba(255, 255, 255, 0.5019607843) !important;
  background: rgba(255, 255, 255, 0.1019607843) !important;
  border: 1px solid rgba(255, 255, 255, 0.1019607843) !important;
}

.rJnamHKcIkhbaplAxoHm {
  background: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.8) !important;
  opacity: 0.5 !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-image-source: none !important;
}

.C7L4aYXST199UoHysvfs {
  border: 1px solid;
  background: rgba(69, 174, 255, 0.2);
  backdrop-filter: blur(1px);
  border-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%);
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  opacity: 1;
  color: white;
}
.C7L4aYXST199UoHysvfs:hover {
  background: rgba(69, 174, 255, 0.4) !important;
  opacity: 0.9 !important;
  color: white !important;
  border-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%) !important;
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
}

.PmV0ICIftsQf4Ud0PKuA {
  border: 1px solid;
  background: rgba(141, 113, 255, 0.2);
  backdrop-filter: blur(1px);
  border-image-source: linear-gradient(93.94deg, #8D71FF 0%, rgba(60, 49, 104, 0) 100%);
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  opacity: 1;
  color: white;
}
.PmV0ICIftsQf4Ud0PKuA:hover {
  background: rgba(141, 113, 255, 0.5019607843) !important;
  color: white !important;
  opacity: 1 !important;
  border: 1px solid #8D71FF !important;
}
.PmV0ICIftsQf4Ud0PKuA[disabled]:hover {
  color: rgba(255, 255, 255, 0.5019607843) !important;
  background: rgba(255, 255, 255, 0.1019607843) !important;
  border: 1px solid rgba(255, 255, 255, 0.5019607843) !important;
}

.t4cOO69YM6V7JszTNi2l {
  border: 1px solid;
  background: rgba(255, 204, 38, 0.2);
  backdrop-filter: blur(1px);
  border-image-source: linear-gradient(93.94deg, #FFCC26 0%, rgba(255, 204, 38, 0) 100%);
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  opacity: 1;
  color: white;
}
.t4cOO69YM6V7JszTNi2l:hover {
  background: rgba(255, 204, 38, 0.5019607843) !important;
  color: white !important;
  opacity: 1 !important;
  border: 1px solid #FFCC26 !important;
}

.LnaR2_M1qxYAXTSGif2f {
  border: 1px solid;
  background: rgba(255, 80, 1, 0.2);
  backdrop-filter: blur(1px);
  border-image-source: linear-gradient(93.94deg, #FF5001 0%, rgba(255, 80, 1, 0) 100%);
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  opacity: 1;
  color: white;
}
.LnaR2_M1qxYAXTSGif2f:hover {
  background: rgba(255, 80, 1, 0.5019607843) !important;
  color: white !important;
  opacity: 1 !important;
  border: 1px solid #FF5001 !important;
}

.RFIN8XQaf3hK0ILalkv9 {
  border: 1px solid;
  background: rgba(0, 209, 140, 0.2);
  backdrop-filter: blur(1px);
  border-image-source: linear-gradient(93.94deg, #00D18C 0%, rgba(0, 209, 140, 0) 100%);
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  opacity: 1;
  color: white;
}
.RFIN8XQaf3hK0ILalkv9:hover {
  background: rgba(0, 209, 140, 0.5019607843) !important;
  color: white !important;
  opacity: 1 !important;
  border: 1px solid #00D18C !important;
}

.jmH8GGrnonSAsQbAwaGw {
  border: 1px solid;
  background: rgba(118, 234, 255, 0.2);
  backdrop-filter: blur(1px);
  border-image-source: linear-gradient(93.94deg, #76EAFF 0%, rgba(41, 104, 153, 0) 100%);
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  opacity: 1;
  color: white;
}
.jmH8GGrnonSAsQbAwaGw:hover {
  background: rgba(118, 234, 255, 0.5019607843) !important;
  color: white !important;
  opacity: 1 !important;
  border: 1px solid #76EAFF !important;
}

.FYLE_kH5dNaS_zyQfyiN {
  background: transparent;
  backdrop-filter: blur(1px);
  border: 1px solid;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.0392156863);
  border-radius: 5px;
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  color: white !important;
  opacity: 1;
  border-image-source: linear-gradient(93.94deg, #8D71FF 0%, rgba(60, 49, 104, 0) 100%) !important;
}
.FYLE_kH5dNaS_zyQfyiN:hover {
  background: rgba(255, 255, 255, 0.1019607843) !important;
  opacity: 1 !important;
}

.d5yTkvloL2fbjCo5282D {
  background: transparent;
  backdrop-filter: blur(1px);
  border: 1px solid;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.0392156863);
  border-radius: 5px;
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  color: white !important;
  opacity: 1;
  border-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0.5) 100%);
}
.d5yTkvloL2fbjCo5282D:hover {
  background: rgba(255, 255, 255, 0.1019607843) !important;
  opacity: 1 !important;
}

.QI0j7qRgEpZFwc05Cz5p {
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  box-shadow: inset 0px 2px px #FFFFFF, inset 0px -4px 4px rgba(0, 48, 73, 0.25), inset 0px 0px 25px #FFFFFF;
  border-radius: 8px;
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #003049;
}
.QI0j7qRgEpZFwc05Cz5p:hover {
  color: 1px solid #48CAE4;
}
.QI0j7qRgEpZFwc05Cz5p > ._qLXWE36Y3wnE7_nfGh5 {
  fill: #003049;
  stroke: #003049;
}
.QI0j7qRgEpZFwc05Cz5p > .plV4OFCIYvubAq6Cd_PT {
  margin: 0 15px 0 0 !important;
}
.QI0j7qRgEpZFwc05Cz5p[disabled] {
  cursor: not-allowed;
  background: #c4c4c4;
  border: 1px solid #c4c4c4;
}
.QI0j7qRgEpZFwc05Cz5p[disabled]:hover {
  color: #003049;
}
.QI0j7qRgEpZFwc05Cz5p[disabled]:hover > ._qLXWE36Y3wnE7_nfGh5 {
  fill: initial;
}

.xAncdHs887PeRm39FoP3 {
  border: 1px solid;
  border-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%) !important;
  border-image-slice: 1; /* use the whole gradient */
  border-image-width: 1; /* match your 1px border */
  border-image-outset: 0;
  border-image-repeat: stretch;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.0392156863) !important;
  background: none !important;
  color: white;
}
.xAncdHs887PeRm39FoP3:hover {
  background: rgba(255, 255, 255, 0.1019607843) !important;
  color: white !important;
}
.xAncdHs887PeRm39FoP3:active {
  background: linear-gradient(180deg, rgba(0, 48, 73, 0.6) 21.35%, rgba(0, 48, 73, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);
}`, "",{"version":3,"sources":["webpack://./src/Components/ButtonNew/Button.module.scss"],"names":[],"mappings":"AACA;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EAEA,qBAAA;EAEA,gBAAA;EACA,aAAA;EACA,kBAAA;EAEA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AAHD;AAIC;EAzBD;IA0BE,eAAA;EADA;AACF;AAGC;EA7BD;IA8BE,kBAAA;IACA,mBAAA;EAAA;AACF;AACC;EAjCD;IAkCE,gBAAA;IACA,mBAAA;IACA,YAAA;EAEA;AACF;AADC;EAtCD;IAuCE,iBAAA;IACA,kBAAA;EAIA;AACF;AAFC;EACC,gCAAA;EACA,wBAAA;EACA,sBAAA;AAIF;AADC;EACC,4BAAA;AAGF;AACC;EACC,mBAAA;EACA,wDAAA;EACA,mDAAA;EACA,mDAAA;AACF;AAAE;EACC,qBAAA;EACA,mDAAA;EACA,wDAAA;EACA,8DAAA;AAEH;;AAGA;EACC,+CAAA;EACA,0CAAA;EACA,uBAAA;EACA,0CAAA;EACA,oCAAA;AAAD;;AAGA;EAEC,iBAAA;EACA,mCAAA;EACA,0BAAA;EACA,sFAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AADD;AAGC;EACC,8CAAA;EACA,uBAAA;EACA,uBAAA;EACA,iGAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;AADF;;AAMA;EAEC,iBAAA;EACA,oCAAA;EACA,0BAAA;EACA,qFAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AAJD;AAMC;EACC,wDAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;AAJF;AAMC;EACC,mDAAA;EACA,wDAAA;EACA,8DAAA;AAJF;;AAQA;EAEC,iBAAA;EACA,mCAAA;EACA,0BAAA;EACA,sFAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AAND;AAQC;EACC,uDAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;AANF;;AAUA;EAEC,iBAAA;EACA,iCAAA;EACA,0BAAA;EACA,oFAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AARD;AASC;EACC,qDAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;AAPF;;AAWA;EAEC,iBAAA;EACA,kCAAA;EACA,0BAAA;EACA,qFAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AATD;AAUC;EACC,sDAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;AARF;;AAYA;EAEC,iBAAA;EACA,oCAAA;EACA,0BAAA;EACA,sFAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AAVD;AAWC;EACC,wDAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;AATF;;AAaA;EAEC,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,uBAAA;EACA,UAAA;EACA,gGAAA;AAXD;AAYC;EACC,wDAAA;EAEA,qBAAA;AAXF;;AAgBA;EAEC,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,uBAAA;EACA,UAAA;EACA,wFAAA;AAdD;AAgBC;EACC,wDAAA;EACA,qBAAA;AAdF;;AAmBA;EAIC,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0GAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,cAAA;AAnBD;AAoBC;EACC,wBAAA;AAlBF;AAqBC;EACC,aAAA;EACA,eAAA;AAnBF;AAsBC;EACC,6BAAA;AApBF;AAsBC;EACC,mBAAA;EACA,mBAAA;EACA,yBAAA;AApBF;AAqBE;EACC,cAAA;AAnBH;AAoBG;EACC,aAAA;AAlBJ;;AAyBA;EAEC,iBAAA;EACA,iGAAA;EACA,qBAAA,EAAA,2BAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,kEAAA;EACA,2BAAA;EACA,YAAA;AAvBD;AAwBC;EACC,wDAAA;EACA,uBAAA;AAtBF;AAwBC;EACC,6HAAA;AAtBF","sourcesContent":["\r\n.button {\r\n\tmax-width: 100%;\r\n\twidth: fit-content;\r\n\twhite-space: pre;\r\n\theight: 48px;\r\n\ttransition: all 0.2s ease-in-out;\r\n\tflex-direction: row;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tmin-width: 92px;\r\n\r\n\t/* Proposal Buttons */\r\n\r\n\t/* Auto layout */\r\n\tdisplay: flex;\r\n\tpadding: 12px 16px;\r\n\r\n\tbackdrop-filter: blur(1px);\r\n\tborder-radius: 2px;\r\n\tfont-family: 'Bai Jamjuree';\r\n\tfont-style: normal;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n\tline-height: 24px;\r\n\tbackground: transparent;\r\n\t@media (max-width: 1500px) {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\r\n\t@media (max-width: 1200px ) {\r\n\t\tpadding-left: 12px;\r\n\t\tpadding-right: 12px;\r\n\t}\r\n\t@media (max-width: 400px) or (max-height: 750px) {\r\n\t\tpadding-top: 8px;\r\n\t\tpadding-bottom: 8px;\r\n\t\theight: 40px;\r\n\t}\r\n\t@media (max-width: 380px ) {\r\n\t\tpadding-left: 8px;\r\n\t\tpadding-right: 8px;\r\n\t}\r\n\r\n\t& > .buttonIcon {\r\n\t\ttransition: all 0.2s ease-in-out;\r\n\t\tmargin: auto 0 auto 15px;\r\n\t\tmin-width: fit-content;\r\n\t}\r\n\r\n\t& > .leftIcon {\r\n\t\tmargin: 0 8px 0 0 !important;\r\n\t}\r\n\r\n\r\n\t&[disabled] {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground: #FFFFFF1A !important;\r\n\t\tborder: 1px solid #FFFFFF1A;\r\n\t\tcolor: #FFFFFF80 !important;\r\n\t\t&:hover {\r\n\t\t\topacity: 1 !important;\r\n\t\t\tcolor: #FFFFFF80 !important;\r\n\t\t\tbackground: #FFFFFF1A !important;\r\n\t\t\tborder: 1px solid #FFFFFF1A !important;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.inActive {\r\n\tbackground: rgba(255, 255, 255, 0.2) !important;\r\n\tcolor: rgba(255, 255, 255, 0.8) !important;\r\n\topacity: 0.5 !important;\r\n\tborder: 1px solid rgba(255, 255, 255, 0.2);\r\n\tborder-image-source: none !important;\r\n}\r\n\r\n.primary {\r\n\t@extend .button;\r\n\tborder: 1px solid;\r\n\tbackground: rgba(69, 174, 255, 0.2);\r\n\tbackdrop-filter: blur(1px);\r\n\tborder-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%);\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\topacity: 1;\r\n\tcolor: white;\r\n\r\n\t&:hover {\r\n\t\tbackground: rgba(69, 174, 255, 0.4) !important;\r\n\t\topacity: 0.9 !important;\r\n\t\tcolor: white !important;\r\n\t\tborder-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%) !important;\r\n\t\tborder-image-slice: 1;          /* use the whole gradient */\r\n\t\tborder-image-width: 1;          /* match your 1px border */\r\n\t\tborder-image-outset: 0;\r\n\t\tborder-image-repeat: stretch;\r\n\r\n\t}\r\n}\r\n\r\n.primaryPurple {\r\n\t@extend .button;\r\n\tborder: 1px solid;\r\n\tbackground: rgba(141, 113, 255, 0.2);\r\n\tbackdrop-filter: blur(1px);\r\n\tborder-image-source: linear-gradient(93.94deg, #8D71FF 0%, rgba(60, 49, 104, 0) 100%);\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\topacity: 1;\r\n\tcolor: white;\r\n\r\n\t&:hover {\r\n\t\tbackground: #8D71FF80 !important;\r\n\t\tcolor: white !important;\r\n\t\topacity: 1 !important;\r\n\t\tborder: 1px solid #8D71FF !important;\r\n\t}\r\n\t&[disabled]:hover {\r\n\t\tcolor: #FFFFFF80 !important;\r\n\t\tbackground: #FFFFFF1A !important;\r\n\t\tborder: 1px solid #FFFFFF80 !important;\r\n\t}\r\n}\r\n\r\n.primaryYellow {\r\n\t@extend .button;\r\n\tborder: 1px solid;\r\n\tbackground: rgba(255, 204, 38, 0.2);\r\n\tbackdrop-filter: blur(1px);\r\n\tborder-image-source: linear-gradient(93.94deg, #FFCC26 0%, rgba(255, 204, 38, 0) 100%);\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\topacity: 1;\r\n\tcolor: white;\r\n\r\n\t&:hover {\r\n\t\tbackground: #FFCC2680 !important;\r\n\t\tcolor: white !important;\r\n\t\topacity: 1 !important;\r\n\t\tborder: 1px solid #FFCC26 !important;\r\n\t}\r\n}\r\n\r\n.primaryRed {\r\n\t@extend .button;\r\n\tborder: 1px solid;\r\n\tbackground: rgba(255, 80, 1, 0.2);\r\n\tbackdrop-filter: blur(1px);\r\n\tborder-image-source: linear-gradient(93.94deg, #FF5001 0%, rgba(255, 80, 1, 0) 100%);\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\topacity: 1;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tbackground: #FF500180 !important;\r\n\t\tcolor: white !important;\r\n\t\topacity: 1 !important;\r\n\t\tborder: 1px solid #FF5001 !important;\r\n\t}\r\n}\r\n\r\n.primaryGreen {\r\n\t@extend .button;\r\n\tborder: 1px solid;\r\n\tbackground: rgba(0, 209, 140, 0.2);\r\n\tbackdrop-filter: blur(1px);\r\n\tborder-image-source: linear-gradient(93.94deg, #00D18C 0%, rgba(0, 209, 140, 0) 100%);\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\topacity: 1;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tbackground: #00D18C80 !important;\r\n\t\tcolor: white !important;\r\n\t\topacity: 1 !important;\r\n\t\tborder: 1px solid #00D18C !important;\r\n\t}\r\n}\r\n\r\n.primaryCyan {\r\n\t@extend .button;\r\n\tborder: 1px solid;\r\n\tbackground: rgba(118, 234, 255, 0.2);\r\n\tbackdrop-filter: blur(1px);\r\n\tborder-image-source: linear-gradient(93.94deg, #76EAFF 0%, rgba(41, 104, 153, 0) 100%);\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\topacity: 1;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tbackground: #76EAFF80 !important;\r\n\t\tcolor: white !important;\r\n\t\topacity: 1 !important;\r\n\t\tborder: 1px solid #76EAFF !important;\r\n\t}\r\n}\r\n\r\n.secondaryPurple {\r\n\t@extend .button;\r\n\tbackground: transparent;\r\n\tbackdrop-filter: blur(1px);\r\n\tborder: 1px solid;\r\n\tbox-shadow: 0px 2px 4px 0px #0000000A;\r\n\tborder-radius: 5px;\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\tcolor: white !important;\r\n\topacity: 1;\r\n\tborder-image-source: linear-gradient(93.94deg, #8D71FF 0%, rgba(60, 49, 104, 0) 100%) !important;\r\n\t&:hover {\r\n\t\tbackground: #FFFFFF1A !important;\r\n\r\n\t\topacity: 1 !important;\r\n\t}\r\n\r\n}\r\n\r\n.secondaryBlue {\r\n\t@extend .button;\r\n\tbackground: transparent;\r\n\tbackdrop-filter: blur(1px);\r\n\tborder: 1px solid;\r\n\tbox-shadow: 0px 2px 4px 0px #0000000A;\r\n\tborder-radius: 5px;\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\tcolor: white !important;\r\n\topacity: 1;\r\n\tborder-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0.5) 100%);\r\n\r\n\t&:hover {\r\n\t\tbackground: #FFFFFF1A !important;\r\n\t\topacity: 1 !important;\r\n\t}\r\n\r\n}\r\n\r\n.primaryLight {\r\n\t@extend .button;\r\n\r\n\r\n\tbackground: #FFFFFF;\r\n\tborder: 1px solid #FFFFFF;\r\n\tbox-sizing: border-box;\r\n\tbox-shadow: inset 0px 2px px #FFFFFF, inset 0px -4px 4px rgba(0, 48, 73, 0.25), inset 0px 0px 25px #FFFFFF;\r\n\tborder-radius: 8px;\r\n\tfont-family: Chakra Petch;\r\n\tfont-style: normal;\r\n\tfont-weight: bold;\r\n\tfont-size: 18px;\r\n\ttext-align: center;\r\n\tfont-feature-settings: 'pnum' on, 'lnum' on;\r\n\tcolor: #003049;\r\n\t&:hover {\r\n\t\tcolor: 1px solid #48CAE4;\r\n\t}\r\n\r\n\t& > .buttonIcon {\r\n\t\tfill: #003049;\r\n\t\tstroke: #003049;\r\n\t}\r\n\r\n\t& > .leftIcon {\r\n\t\tmargin: 0 15px 0 0 !important;\r\n\t}\r\n\t&[disabled] {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground: #c4c4c4;\r\n\t\tborder: 1px solid #c4c4c4;\r\n\t\t&:hover {\r\n\t\t\tcolor: #003049;\r\n\t\t\t& > .buttonIcon {\r\n\t\t\t\tfill: initial;\r\n\t\t\t}\r\n\t\t}\r\n\t\t\r\n\t}\r\n}\r\n\r\n.secondary  {\r\n\t@extend .button;\r\n\tborder: 1px solid;\r\n\tborder-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%) !important;\r\n\tborder-image-slice: 1;          /* use the whole gradient */\r\n\tborder-image-width: 1;          /* match your 1px border */\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\tbox-shadow: 0px 2px 4px 0px #0000000A !important;\r\n\tbackground: none !important;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tbackground: #FFFFFF1A !important;\r\n\t\tcolor: white !important;\r\n\t}\r\n\t&:active {\r\n\t\tbackground: linear-gradient(180deg, rgba(0, 48, 73, 0.6) 21.35%, rgba(0, 48, 73, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `IHVVeG3MK75UGSdWUBIE`,
	"secondary": `xAncdHs887PeRm39FoP3`,
	"primaryLight": `QI0j7qRgEpZFwc05Cz5p`,
	"secondaryBlue": `d5yTkvloL2fbjCo5282D`,
	"secondaryPurple": `FYLE_kH5dNaS_zyQfyiN`,
	"primaryCyan": `jmH8GGrnonSAsQbAwaGw`,
	"primaryGreen": `RFIN8XQaf3hK0ILalkv9`,
	"primaryRed": `LnaR2_M1qxYAXTSGif2f`,
	"primaryYellow": `t4cOO69YM6V7JszTNi2l`,
	"primaryPurple": `PmV0ICIftsQf4Ud0PKuA`,
	"primary": `C7L4aYXST199UoHysvfs`,
	"buttonIcon": `_qLXWE36Y3wnE7_nfGh5`,
	"leftIcon": `plV4OFCIYvubAq6Cd_PT`,
	"inActive": `rJnamHKcIkhbaplAxoHm`
};
export default ___CSS_LOADER_EXPORT___;
